<template>
  <div>
    <div class="m-v-10">
      <div>方案产品：</div>
      <div class="m-v-10">
        <el-table border size="mini" :data="solutionForm.cropSolutionProductList">
          <el-table-column label="序号" type="index" width="50" align="center"/>
          <el-table-column label="目标" prop="target" align="center" width="100px">
          </el-table-column>
          <el-table-column prop="productName" label="产品" show-overflow-tooltip min-width="150px">
          </el-table-column>
          <el-table-column label="成分" prop="ingredient" align="center" min-width="150px">
          </el-table-column>
          <el-table-column label="剂型" prop="dosage" align="center" width="100px">
          </el-table-column>

          <el-table-column label="用药量/兑水量" prop="spec" align="center" width="200px">
            <template slot-scope="scope">
              <span>{{ scope.row.spec }}{{ scope.row.unit }} / {{ solutionForm.waterConsumption }}{{
                  solutionForm.unit
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="稀释倍数" prop="dilutionRatio" align="center" width="150px">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolutionProduct',
  props: {
    solutionForm: {
      type: Object,
      default: () => {
        return {
          waterConsumption: '',
          unit: '',
          cropSolutionProductList: []
        }
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/crop/solution/period/component/SolutionProduct.vue